import { useFormik } from "formik"

export default function useFormikForm({
    initialValues,
    validationSchema,
    handleSubmit,
    initialTouched,
}) {
    const formikProps = useFormik({
        initialValues,
        validationSchema,
        onSubmit: handleSubmit,
        validateOnMount: true,
        initialTouched,
    })

    function mapFormikProps() {
        return {
            values: formikProps.values,
            onChange: (field) => (value) =>
                formikProps.setFieldValue(field, value),
            bulkChange: formikProps.setValues,
            errors: formikProps.errors,
            touched: formikProps.touched,
            onBlur: (field) => () => formikProps.setFieldTouched(field),
            setTouched: formikProps.setTouched,
            isValid: formikProps?.isValid,
            reset: formikProps.resetForm,
            handleSubmit: formikProps.handleSubmit,

            getFieldProps: (field) => {
                const rawProps = formikProps?.getFieldProps(field)
                const rawMeta = formikProps?.getFieldMeta(field)
                const onChange = (value) =>
                    formikProps.setFieldValue(field, value)
                const onBlur = () => formikProps.setFieldTouched(field)
                const error = rawMeta?.touched && rawMeta?.error
                const value = rawProps?.value
                const checked = rawProps?.value

                return { onChange, onBlur, error, value, checked }
            },
        }
    }

    return mapFormikProps()
}
